
<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import inutForm from './inut-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            filter: '',
            metadata: this.$store.getters.getEntities.metadata,
            params: {},
            advFilter: {}, //objeto para o filtro avançado da pesquisa de notas
            filterList: [], //lista de filtros aplicados que são exibidos em tela
        }
    },
    computed: {
        inutList: function () {
            return this.$store.getters.getInutList
        },
    },
    methods: {
        handleEdit (codinut) {
            //abre a tela de edicao
            this.crud = SysVars.crudU //operacao de edicao
            this.params = {}
            this.params.codinut = codinut 
            this.showForm = true; //exibe o form de manutencao
        },

        handleView (codinut) {
            //abre a tela de edicao
            this.crud = SysVars.crudView //visualizacao
            this.params = {}
            this.params.codinut = codinut 
            this.showForm = true; //exibe o form de manutencao
        },

        handleAction (id, keyIndex) {

        },
        
        handleIncluir () {
            //abre a tela de edicao
            this.crud = SysVars.crudI //operacao de inclusao
            this.params.codinut = 0
            this.showForm = true //exibe o form de manutencao
        },

        closeForm() {
            this.showForm = false
            this.loadData()
        },

        handleSearch(value) {
            //efetua a pesquisa
            this.filter = ''
            if (value != '') {
                this.filter = '{"$or":[{"nfinicial":{"$eq":"' + value + '"}},{"nffinal":{"$eq":"' + value + '"}}]}'
            }
            this.loadData()
        },
        
        loadData() {
            this.$store.dispatch('loadInut', { filter: this.filter} )
        },

        data (value) {
            return formatDate(value)
        },        
    },

    components: {
        BarList, BarGrid, inutForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false"
                :xls-button="false"
                single-entity="Inutilização de Numeração" 
                plural-entity="Inutilizacao de Numeração"
                @search="handleSearch"
                @new="handleIncluir"
                @refresh="loadData"
                title-search="Pesquise pelo número da nota">
            </bar-list>
            <div class="default-container mt-2">
                <alert v-if="inutList.length == 0" type="norecord"></alert>
                <div class="mainbox" v-for="(inut, index) in inutList" :key="index">
                    <div class="box">
                        <div class="row">
                            <div class="col-md-2 col-4">
                                <v-label :metadata-field="metadata.inut.data"></v-label><br>
                                <span class="data-list">{{ data(inut.data) }}</span>
                            </div>
                            <div class="col-md-2 col-2">
                                <v-label :metadata-field="metadata.inut.serie"></v-label><br>
                                <span class="data-list">{{ inut.serie }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <v-label :metadata-field="metadata.inut.nfinicial"></v-label><br>
                                <span class="data-list">{{ inut.nfinicial }}</span>
                            </div>
                            <div class="col-md-2 col-3">
                                <v-label :metadata-field="metadata.inut.nffinal"></v-label><br>
                                <span class="data-list">{{ inut.nffinal }}</span>
                            </div>
                            <div class="col-md-2 col-6">
                                <v-label :metadata-field="metadata.inut.nprot"></v-label><br>
                                <span class="data-list">{{ inut.nprot }}</span>
                                <span v-if="inut.nprot" class="badge badge-green">Autorizado</span>
                            </div>
                            <div class="col-md-2 col-6">
                                <bar-grid v-if="inut.nprot == null"
                                    :options="{barDefault: true, btnEdit: true, btnDelete: false, btnView: true}"
                                    :moreActions="[]"
                                    @view="handleView(inut.codinut)"
                                    @edit="handleEdit(inut.codinut)">
                                </bar-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <inut-form v-if="showForm" :params="params" :crud="crud" v-on:closeform="closeForm"></inut-form>
    </div>
</template>


<style>

</style>



// WEBPACK FOOTER //
// src/forms/inut-list.vue